import { render, staticRenderFns } from "./f_users.vue?vue&type=template&id=1261b744&scoped=true&"
import script from "./f_users.vue?vue&type=script&lang=js&"
export * from "./f_users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1261b744",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1261b744')) {
      api.createRecord('1261b744', component.options)
    } else {
      api.reload('1261b744', component.options)
    }
    module.hot.accept("./f_users.vue?vue&type=template&id=1261b744&scoped=true&", function () {
      api.rerender('1261b744', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/user/profile/tabs/f_exchange/f_users.vue"
export default component.exports